<div uiCustomization [elementName]="'gen-add-test'">
  <button *ngIf="!oldStyle"  class="new-test btn Auto_New_Test_Button" (click)="addTest()"><i class="icon__plus"></i> {{'NEW' | translate}}</button>


  <a href="javascript:void(0)" *ngIf="oldStyle" type="button" (click)="addTest()" class="grow-parent new-test-section">
    <div class="grow-child" style="display: inline-block">
              <span class="icon__add" style="font-size: 1.78rem;padding-right: 0.71rem;position: relative;color: white;">
              </span>
    </div>
    <span class="new-test-bold" style="white-space: normal">{{'New' | stringTranslate}}</span>
  </a>
</div>
